import React from 'react';
import { Container, Box } from '@mui/material';
import SectionHeader from './SectionHeader';
import TestimonialCard from './TestimonialCard';

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "This is actually pretty disruptive. I've watched several clients spend $150-200/month on similar tools that barely deliver actionable insights. The price point alone makes this accessible to mom-and-pop shops who typically can't afford enterprise feedback systems.",
      authorTitle: "Founder & CEO",
      authorCompany: "AI Automation Agency, Ontario, Canada"
    },
    {
      quote: "With over 500 locations across the UK, we're always looking for innovative ways to stand out in the competitive pizza market. Sashy identified that delivery delays were a key issue across our operations - something we suspected but couldn't quantify before. Now we have clear data to improve customer experience.",
      authorTitle: "Operations Director",
      authorCompany: "Pizza Chain (500+ UK locations), UK"
    },
    {
      quote: "As food consultants, we help restaurants make strategic decisions. Sashy lets us quantify customer experience issues - like when a burrito chain discovered their 'cold food' complaints were actually costing them revenue. Now they can make data-driven investment decisions.",
      authorTitle: "Co-Founder & Managing Director",
      authorCompany: "Food and Beverage Consultancy, London, UK"
    },
    {
      quote: "Sashy identified that customers were specifically complaining about the texture of our Canelés - something we hadn't picked up on from reading reviews individually. This turned out to be one of our largest product quality issues that we could actually address.",
      authorTitle: "Co-Founder",
      authorCompany: "Bakery, London, UK"
    },
    {
      quote: "We run SEO audits for around 10 clients monthly, and Sashy's revenue impact feature has become a real value-add. Now we can show clients exactly how their Google rating affects their bottom line - it's transformed our audit presentations.",
      authorTitle: "SEO Specialist",
      authorCompany: "Marketing Agency, MI, USA"
    },
    {
      quote: "As a wellness service company, customer satisfaction is everything to us. We use Sashy's monthly timeline to track reviews and ratings across all our cleaning divisions - it helps us spot service quality trends before they become bigger issues.",
      authorTitle: "Founder",
      authorCompany: "Home Wellness Company, Dubai, UAE"
    }
  ];

  return (
    <Box id="testimonials-section" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <SectionHeader 
          title="What Our Customers Say"
        />
        
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4, justifyContent: 'center' }}>
          {testimonials.map((testimonial, index) => (
            <Box
              key={index}
              sx={{
                flexGrow: 1,
                flexBasis: { xs: '100%', md: 'calc(50% - 16px)' },
                maxWidth: { xs: '100%', md: 'calc(50% - 16px)' }
              }}
            >
              <TestimonialCard
                quote={testimonial.quote}
                authorTitle={testimonial.authorTitle}
                authorCompany={testimonial.authorCompany}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialsSection; 